import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { format } from 'date-fns';
// import Rectangle6 from '../../../images/adminConsole/Rectangle6.png';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    avatar: {
        width: '57px',
        borderRadius: '8px',
        // borderRadius: '100px',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        paddingTop: 20,
        paddingBottom: 20,
        height: '473px',
        overflowY: 'auto',
    },
    heading: {
        fontSize: 22,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 10,
        marginTop: 10,
        width: 700,
    },
    subHeading: {
        fontSize: 17,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 20,
    },
    arrowsBody: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 155,
        position: 'absolute',
        width: 688,
        marginLeft: 10,
    },

    contentBody: {
        paddingLeft: 50,
        paddingRight: 50,
        width: 600,
        marginTop: 100,
    },
    foQ: {
        marginTop: 40,
    },
}));

const ContactUsMessageModal = ({ data }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <span onClick={handleOpen}>Message</span>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <div className={classes.heading}>Contact Us Submission</div>
                        <div className={classes.subHeading}>Submitted By : {data?.firstName + ' ' + data?.lastName}</div>
                        <div className={classes.subHeading}>Date of Submission : {format(new Date(data?.createDt), 'MM/dd/yyyy')}</div>
                        <div className={classes.contentBody}>
                            <p>
                                -{' '}
                                {(data?.softwareSuggestion && 'I have a software improvement suggestion') ||
                                    (data?.reportBug && 'I need to report a glitch/bug') ||
                                    (data?.general && 'General Recommendation') ||
                                    (data?.media && 'I am from the media.')}
                            </p>
                            <p>
                                <b>Message: </b> {data?.message}
                            </p>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
};

export default ContactUsMessageModal;
